import { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import { map, size } from "lodash";
import cx from "classnames";
import { VerticalScrollSlider } from "../../../components/verticalScrollSlider";

type renderItem = {
    component: React.ReactNode;
    title?: string;
};

type SyncScrollLayoutProps = {
    viewerRenderer: renderItem[];
    editorRenderer: renderItem[];
    showEditor: boolean;
    defaultSelectedIndex?: number;
    animateViewerScroll?: boolean;
    animateEditorScroll?: boolean;
    editorGapBetweenSections?: number;
    classnames?: string;
    enablePrevAndNextEditor?: boolean;
}

export const SyncScrollLayout = ({
    viewerRenderer,
    editorRenderer,
    showEditor,
    defaultSelectedIndex = 0,
    animateViewerScroll = true,
    animateEditorScroll = true,
    editorGapBetweenSections = 3,
    classnames,
    enablePrevAndNextEditor = false,
}: SyncScrollLayoutProps) => {
    
    const [syncScroll, setSyncScroll] = useState(defaultSelectedIndex); // sync state

    useEffect(() => { // When default selected index changes from parent
        setSyncScroll(defaultSelectedIndex);
    },[defaultSelectedIndex]);

    return (<>
     { size(viewerRenderer) > 0 && size(editorRenderer) > 0 && (
        <div className={cx(styles.syncScrollContainer, classnames)}>
        
        {/* Viewer */}
        { animateViewerScroll ? <VerticalScrollSlider 
            listOfRenders={viewerRenderer}
            selectedIndex={syncScroll}
            gap={2}
            classnames={cx(styles.viewerRendererSection, styles.previewAnimate, {
                [styles.dropScale]: showEditor, // when editor is not shown, we want to scale down the viewer a bit to give more emphasis on it
            })}
            enableWheelScroll={false} // disable wheel scroll for viewer, as we want to control it from editor only
          /> : <div className={cx(styles.noScrollAnimationContainer, styles.previewAnimate, {
                [styles.dropScale]: showEditor, // when editor is not shown, we want to scale down the viewer a bit to give more emphasis on it
            })}>
              <div className={styles.innerContainer}>
                {map(viewerRenderer, (item, idx) => <> {item.component} </>)}
               </div>
          </div> }

        {/* Editor */}
        <div className={styles.editorRendererSection} style={{ transform: showEditor ? 'translateX(0%)' : 'translateX(calc(100% + 1rem))'}}>
           { animateEditorScroll ? <VerticalScrollSlider 
                listOfRenders={editorRenderer}
                selectedIndex={syncScroll}
                gap={editorGapBetweenSections}
                enablePrevAndNext={enablePrevAndNextEditor}
                onChange={(i) => {
                    setSyncScroll(i);
                }}/> : <div className={styles.noScrollAnimationContainer}>
                    <div className={styles.innerContainer}>
                      {map(editorRenderer, (item, idx) => <> {item.component} </>)}
                    </div>
                </div> }
        </div>
     </div> ) }
    </>)
}


